export const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
};

export const truncate = (str, n, useWordBoundary) => {
  if (str.length <= n) {
    return str;
  }
  const subString = str.substr(0, n - 1);
  return (
    (useWordBoundary
      ? subString.substr(0, subString.lastIndexOf(' '))
      : subString) + '...'
  );
};

// utility for checking if a string ends with a suffix
export const endsWith = (str = '', suffix = '') =>
  str.indexOf(suffix, str.length - suffix.length) !== -1;

// utility for checking if a link/path is currently active
export const isLinkActive = (path) => {
  const location = window.location || { pathname: '/' };
  const { pathname } = location;
  return endsWith(pathname, path);
};
